export default function premade() {
    var productID = 31331,
        components = [
            {
                id: 15017,
                name: 'Leg Up&reg; Joint Pellets',
                isColiCareEligible: !1,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Chondroitin Sulfate',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Chondroitin'
                        },
                        {
                            title: 'Glucosamine',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#glucosamine'
                        },
                        {
                            title: 'MSM',
                            url: 'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#msm'
                        },
                        {
                            title: 'Vitamin C',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#vitaminC'
                        }
                    ],
                    clinicalResearchLink: ''
                },
                productLabelImage: {
                    type: 'label',
                    url: '//img.smartpak.com/images/views/productclass/productlabel/25017_LegUpJoint_6-2017.jpg',
                    attributes: null
                },
                productId: 2109779857
            },
            {
                id: 6313,
                name: 'SmartDigest&reg;',
                isColiCareEligible: !1,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Digestive Enzymes',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#digestiveenzymes'
                        },
                        {
                            title: 'Fenugreek',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#Fenugreek'
                        },
                        {
                            title: 'Prebiotics',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#prebiotics'
                        },
                        {
                            title: 'Probiotics',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#probiotics'
                        },
                        {
                            title: 'Yeast',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#yeast'
                        }
                    ],
                    clinicalResearchLink: ''
                },
                productLabelImage: {
                    type: 'label',
                    url: '//img.smartpak.com/images/views/productclass/productlabel/16313_SmartDigest_10.2015.jpg',
                    attributes: null
                },
                productId: 2109695340
            },
            {
                id: 15005,
                name: 'Smart & Simple&trade; Flax',
                isColiCareEligible: !1,
                analysis: null,
                extraInformation: {
                    clinicalResearch: [
                        {
                            title: 'Flax Seed',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#FlaxSeed'
                        },
                        {
                            title: 'Omega 3 Fatty Acids',
                            url:
                                'https://www.smartpakequine.com/content/Supplement-Ingredients-Backed-by-Research#omega3'
                        }
                    ],
                    clinicalResearchLink: ''
                },
                productLabelImage: {
                    type: 'label',
                    url: '//img.smartpak.com/images/views/productclass/productlabel/25005_Flax_SmartSimple_3-2018.jpg',
                    attributes: null
                },
                productId: 2109779786
            }
        ],
        script = document.createElement('script');
    script.async = !0;
    script.onload = function() {
        window.premade(components, productID);
    };
    script.src = '/jsscripts/dycampaigns/premade.js';
    document.getElementsByTagName('head')[0].appendChild(script);
}
